/**
 * addit Theme — Shared Launch Page Animation Helpers
 * Used by launch-proof and launch-recipe sections.
 */
window.LaunchAnimations = {
  hide: function (el, extra) {
    if (!el) return;
    el.style.opacity = '0';
    el.style.transition = 'none';
    if (extra) Object.assign(el.style, extra);
  },

  show: function (el, delay, toTransform, dur) {
    if (!el) return;
    dur = dur || 520;
    setTimeout(function () {
      el.style.transition = 'opacity ' + dur + 'ms ease, transform ' + dur + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.opacity = '1';
      el.style.transform = toTransform || '';
    }, delay);
  },

  countUp: function (el, target, dur) {
    if (!el) return;
    /* Keep the target's decimal precision and render German comma decimals */
    var decimals = (String(target).split('.')[1] || '').length;
    var start = performance.now();
    (function step(now) {
      var t = Math.min((now - start) / dur, 1);
      var ease = 1 - Math.pow(1 - t, 3);
      el.textContent = (target * ease).toFixed(decimals).replace('.', ',');
      if (t < 1) requestAnimationFrame(step);
    })(start);
  }
};
